<template>
    <sp-360-panel class="chart-widget" :title="$t(title)" :tooltipOptions="topTooltipOptions" :footerText="$t(footerText, {fonte: footerFonte, data: footerData})" :footerComplementar="$t(footerComplementar)">
        <sp360-chart :data="data" type="line" :options="options" class="chart"/>
    </sp-360-panel>
</template>

<script>
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'grafico-linha',
  components: { Sp360Chart, Sp360Panel },
  data: () => ({
    topTooltipOptions: {
      content: '', placement: 'bottom',
    },
  }),

  props: {
    titulo: { type: String, default: '' },
    data: { type: Object, default: () => { [] } },
    cores: { type: Array, default: () => { [] } },
    options: { type: Object, default: () => { [] } },
    title: { type: String, default: '' },
    tooltipText: { type: String, default: '' },
    footerText: { type: String, default: '' },
    footerFonte: { type: String, default: '' },
    footerData: { type: String, default: '' },
    footerComplementar: { type: String, default: '' },
  },

  mounted () {
    this.topTooltipOptions.content = this.$t(this.tooltipText)
  },

  methods: {
  },
}
</script>

<style>

</style>
